function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.971,
    height: 20.971,
    viewBox: "0 0 20.971 20.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "x (2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 11",
    transform: "rotate(45 2.828 13.657)",
    style: {
      fill: "none",
      stroke: "#2973f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M12 0 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 12",
    transform: "rotate(45 2.828 13.657)",
    style: {
      fill: "none",
      stroke: "#2973f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "m0 0 12 12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAddressIcon);
export default __webpack_public_path__ + "static/media/AddAddressIcon.32218322f9cd5709f3381f33cbf0ff49.svg";
export { ForwardRef as ReactComponent };